/**
 * CardIcon — a small, colourful icon badge sitting on the left of a
 * text card. Renders a Twemoji-style native emoji inside a coloured
 * circular tile. Deterministic, no external deps.
 *
 * Later we'll swap the emoji for AI-generated art (Nano Banana) on the
 * same slots — the component API stays identical.
 *
 * Usage:
 *   <CardIcon emoji="🌦️" color="#0284c7" size="md" />
 *
 * Sizes: sm (32), md (40), lg (48) — default md.
 * The color governs BOTH the background tint (color+"18") AND the
 * border ring (color+"33"), so callers only pass one hex.
 */
const SIZE_MAP = {
  sm: { box: 32, font: 18 },
  md: { box: 44, font: 24 },
  lg: { box: 56, font: 30 },
};

export default function CardIcon({
  emoji,
  color = "#059669",
  size = "md",
  className = "",
  testid,
}) {
  const s = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <div
      className={"shrink-0 inline-flex items-center justify-center rounded-2xl " + className}
      style={{
        width: s.box,
        height: s.box,
        background: `linear-gradient(135deg, ${color}22 0%, ${color}0a 100%)`,
        border: `1px solid ${color}33`,
        color,
        fontSize: s.font,
        lineHeight: 1,
      }}
      aria-hidden
      data-testid={testid || "card-icon"}
    >
      <span style={{ filter: "saturate(1.05)" }}>{emoji}</span>
    </div>
  );
}
